import { Box, styled } from '@mui/material';

const MapContainer = styled(Box)`
  position: ${({ isFullScreen }) => (isFullScreen ? 'absolute' : 'initial')};
  left: 0;
  top: 0;
  padding-top: ${({ isFullScreen }) => (isFullScreen ? 0 : '10px')};
  width: ${({ isFullScreen }) => (isFullScreen ? '100vw' : '100%')};
  height: ${({ isFullScreen }) => (isFullScreen ? '100vh' : '800px')};
  z-index: ${({ isFullScreen }) => (isFullScreen ? 2000 : 'inherit')};
`;

export default MapContainer;
